import { navigationSidebarGlobalResource } from '@atlassian/jira-router-resources-navigation-sidebar-global/src/index.tsx';
import { projectsDirectoryPageResource } from '@atlassian/jira-router-resources-project-directories/src/services/index.tsx';

export const adminProjectDirectoryResources = () => [
	navigationSidebarGlobalResource,
	projectsDirectoryPageResource,
];
